export default interface ICasino {
    id: number,
    name: string,
    shortName: string | null,
    nameIdentifier: string,
    website: string | null,
    hasCraps: boolean,
    hasBlackjack: boolean,
    hasRoulette: boolean,
    address: string,
    googlePlacesId: string | null,
    latitude: number | null,
    longitude: number | null,
    rating: number,
    userRatings: number,
    phoneNumber: string | null,
    businessStatus: string,
    hours: any,
    additionalInfo: string | null,
    minBets?: IMinBet[],
    isFavorite?: boolean,
}

export interface IMinBet {
    gameType: string,
    minBet: number,
    verified: boolean,
    reportedAt?: string,
}

// Helper to extract a specific min bet from the minBets array
export function getMinBet(casino: ICasino, gameType: string): number | null {
    const bet = casino.minBets?.find(b => b.gameType === gameType);
    return bet ? bet.minBet : null;
}